/* ==============================================================
   CNC Tools Loader
   Reads window.CNC_TOOLS registry, finds current page handle,
   dynamically injects the matching tool's CSS + JS.
   
   This is the long-term solution: add a new tool = 4 lines in
   the registry, no theme.liquid bloat, no Kalles page processor
   conflicts.
   ============================================================== */
(function() {
  'use strict';
  // Bail on non-page URLs (cart, products, etc.)
  var path = window.location.pathname;
  var match = path.match(/^\/pages\/([a-z0-9-]+)\/?$/i);
  if (!match) return;
  var handle = match[1];
  var registry = window.CNC_TOOLS || {};
  var tool = registry[handle];
  if (!tool) return;
  // Inject CSS (if defined)
  if (tool.css) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = tool.css;
    document.head.appendChild(link);
  }
  // Inject JS (if defined)
  if (tool.js) {
    var script = document.createElement('script');
    script.src = tool.js;
    script.defer = false; // run immediately after load (tool HTML is already in DOM)
    document.head.appendChild(script);
  }
  // Optional: mark body for CSS scoping or analytics
  if (tool.analytics) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cnc_tool_loaded',
      tool_handle: handle,
      tool_name: tool.name || handle
    });
  }
})();